import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Input } from '@angular/core';
import { HeaderProps } from '@bl/components';
import { BlFrontendBaseComponent } from './bl-frontend-base.component';

@Component({
  selector: 'bl-frontend-header',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
})
export class BlFrontendHeaderComponent extends BlFrontendBaseComponent<HeaderProps> {
  @Input() text: HeaderProps['text'];
  @Input() size?: HeaderProps['size'] = 'h1';

  constructor(protected override ref: ElementRef) {
    super(ref);
  }

  protected override getComponentName(): string {
    return 'Header';
  }

  protected override getProps(): HeaderProps {
    return {
      text: this.text,
      size: this.size,
    };
  }
}
